import {
  ObjectComboMappingFormDefaultValues,
  ObjectComboMappingFormProps,
  ObjectComboMappingFormRawValues,
  ObjectComboMappingFormType
} from "./ObjectComboMappingForm";
import {useTranslation} from "react-i18next";
import {useForm} from "@mantine/form";

const getInitialValues = (defaultValues: ObjectComboMappingFormDefaultValues | undefined): ObjectComboMappingFormRawValues => {
  return {
    key: defaultValues?.key,
    value: defaultValues?.value,
    leftObjectId: defaultValues?.leftObject?.id,
    leftObjectType: defaultValues?.leftObject?.type,
    rightObjectId: defaultValues?.rightObject?.id,
    rightObjectType: defaultValues?.rightObject?.type,
  }
}

export type UseObjectComboMappingFormProps = Pick<ObjectComboMappingFormProps, 'defaultValues'> & {}

export function useObjectComboMappingForm(props: UseObjectComboMappingFormProps): ObjectComboMappingFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])

  const form = useForm({
    initialValues: getInitialValues({
      ...defaultValues,
    }),
    validate: {
      key: (value) => value ? undefined : t("common.validation.required", "Required"),
      value: (value) => value ? undefined : t("common.validation.required", "Required"),
      leftObjectId: (value) => value ? undefined : t("common.validation.required", "Required"),
      leftObjectType: (value) => value ? undefined : t("common.validation.required", "Required"),
      rightObjectId: (value) => value ? undefined : t("common.validation.required", "Required"),
      rightObjectType: (value) => value ? undefined : t("common.validation.required", "Required"),
    },
  })

  return form
}
